/**
 * Fındık Minimalist Theme - Global JavaScript
 * Fast, Vanilla JS, Zero Dependencies
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initMobileMenu();
  initAjaxAddToCart();
  initProductVariantSelectors();
});

// Cart Drawer Controller
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  const openButtons = document.querySelectorAll('[data-cart-drawer-trigger]');
  const closeButtons = document.querySelectorAll('[data-cart-drawer-close]');

  if (!drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchCartAndRender();
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));

  closeButtons.forEach(btn => btn.addEventListener('click', closeDrawer));
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });

  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;
}

// Fetch Cart JSON and Render Drawer Content
async function fetchCartAndRender() {
  const container = document.getElementById('CartDrawerItems');
  const subtotalEl = document.getElementById('CartDrawerSubtotal');
  const countBadge = document.querySelectorAll('.cart-count-badge');

  if (!container) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update count badges
    countBadge.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Update Subtotal
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (cart.item_count === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 3rem 1rem; color: var(--color-muted);">
          <p style="font-size: 1.1rem; margin-bottom: 1.5rem;">Sepetiniz henüz boş.</p>
          <a href="/collections/all" class="btn btn-primary" onclick="closeCartDrawer()">Ürünleri Keşfet</a>
        </div>
      `;
      return;
    }

    // Render items
    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-drawer-item" style="display: flex; gap: 1rem; border-bottom: 1px solid var(--color-border); padding-bottom: 1rem;">
          <img src="${item.image ? item.image : ''}" alt="${item.title}" style="width: 72px; height: 72px; object-fit: cover; border-radius: var(--border-radius-sm); background: #eee;">
          <div style="flex: 1;">
            <h5 style="font-size: 1rem; font-family: var(--font-heading); margin-bottom: 0.25rem;">
              <a href="${item.url}">${item.product_title}</a>
            </h5>
            ${item.variant_title ? `<p style="font-size: 0.8rem; color: var(--color-muted); margin-bottom: 0.4rem;">${item.variant_title}</p>` : ''}
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 0.5rem;">
              <span style="font-weight: 600; font-size: 0.95rem;">${formatMoney(item.final_line_price)}</span>
              <div style="display: flex; align-items: center; border: 1px solid var(--color-border); border-radius: var(--border-radius-full); overflow: hidden;">
                <button type="button" style="border: none; background: none; padding: 0.2rem 0.6rem; cursor: pointer;" onclick="updateCartItem('${item.key}', ${item.quantity - 1})">-</button>
                <span style="font-size: 0.85rem; padding: 0 0.4rem;">${item.quantity}</span>
                <button type="button" style="border: none; background: none; padding: 0.2rem 0.6rem; cursor: pointer;" onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    container.innerHTML = html;
  } catch (err) {
    console.error('Sepet yüklenirken hata oluştu:', err);
  }
}

// Update Cart Item Quantity
window.updateCartItem = async function(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    fetchCartAndRender();
  } catch (err) {
    console.error('Ürün güncellenirken hata oluştu:', err);
  }
};

// AJAX Add to Cart Handler
function initAjaxAddToCart() {
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerText : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerText = 'Ekleniyor...';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!res.ok) throw new Error('Sepete ekleme başarısız');

      if (window.openCartDrawer) {
        window.openCartDrawer();
      }
    } catch (err) {
      alert('Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerText = originalText;
      }
    }
  });
}

// Mobile Menu
function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    menu.classList.toggle('active');
  });
}

// Currency Formatter Helper
function formatMoney(cents) {
  if (cents === null || cents === undefined) return '';
  const price = (cents / 100).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return `${price} TL`;
}

// Variant Selection Logic
function initProductVariantSelectors() {
  const variantSelect = document.querySelector('[data-product-variants]');
  if (!variantSelect) return;

  variantSelect.addEventListener('change', (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const price = selectedOption.dataset.price;
    const compareAt = selectedOption.dataset.comparePrice;
    const priceDisplay = document.querySelector('[data-product-price]');
    
    if (priceDisplay && price) {
      priceDisplay.textContent = formatMoney(price);
    }
  });
}
